import { Eye, EyeOff } from "lucide-react";
import { minLength, useTranslate } from "ra-core";
import { useState } from "react";
import { TextInput } from "@/components/admin/text-input";
import { Button } from "@/components/ui/button";

// Same minimum as the users edge function (supabase/functions/users/initialPassword.ts).
const MIN_PASSWORD_LENGTH = 8;

/**
 * Optional password of a new user. Filled, the user signs in with it right
 * away; empty, they get an invitation e-mail to choose one.
 */
export const SalesPasswordInput = () => {
  const translate = useTranslate();
  const [isVisible, setVisible] = useState(false);
  return (
    <div className="relative">
      <TextInput
        source="password"
        type={isVisible ? "text" : "password"}
        autoComplete="new-password"
        inputClassName="pr-10"
        validate={minLength(
          MIN_PASSWORD_LENGTH,
          "resources.sales.create.password_too_short",
        )}
        helperText="resources.sales.create.password_helper"
      />
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="absolute right-1 top-[26px] size-7 text-muted-foreground"
        aria-label={translate(
          isVisible
            ? "resources.sales.create.hide_password"
            : "resources.sales.create.show_password",
        )}
        onClick={() => setVisible(!isVisible)}
      >
        {isVisible ? <EyeOff /> : <Eye />}
      </Button>
    </div>
  );
};
